<template>
<div
  style="position:relative;height:84px;padding-top:4px;"
  @dragenter="dragEnter" @dragleave="dragLeave"
  @dragover="dragOver" @drop="dragDrop"
  >
    <v-card
      :id="`job-${job.xid}`"
      class="mx-1 my-0 jobBlock"
      style="height:80px;user-select:none;"
      draggable="true" @dragstart="dragStart"
      @click="leftClick" @contextmenu.prevent="e=>$emit('rightClick', e)" @dblclick="dblClick"
      >
      <v-card-text ref="cardText" style="pointer-events: none;">
        <v-row class="pt-1">

          <v-col cols="9" class="py-0 text-truncate">
            <span class="font-weight-bold primary--text">{{ job.number }}</span>
          </v-col>
          <v-col cols="3" class="py-0 text-right text-truncate text-caption">
            <span v-if="job.date_promised">Forecast {{ moment(job.date_promised).fromNow() }}</span>
            <span v-else-if="job.date_accepted">Accepted {{ moment(job.date_accepted).fromNow() }}</span>
            <span v-else-if="job.date_enquired">Enquired {{ moment(job.date_enquired).fromNow() }}</span>
            <span v-else>Created {{ moment(job.created_at).fromNow() }}</span>
          </v-col>

          <v-col cols="9" class="py-0 text-truncate">
            <span class="font-weight-bold">{{ job.customer?.name }}</span>
            <span class="mr-4" v-if="job.customer_acc"> - {{ job.customer_acc }}</span>
          </v-col>

          <v-col cols="3" class="py-0 text-right text-truncate text-caption">
            <v-chip label class="ml-2 mb-0" x-small style="position:relative;top:-2px;">{{ job.stage.title }}</v-chip>
          </v-col>
          
          <v-col cols="9" class="py-0 text-truncate">{{ job.description }}</v-col>

          <v-col cols="3" class="py-0 text-right text-truncate text-caption">
            {{ job.tasks_complete }} / {{ job.tasks_total }}
          </v-col>

        </v-row>
      </v-card-text>
    </v-card>

    <div class="indicator" :class="{'dragTop': dragover && dragPos == 'before', 'dragBottom': dragover && dragPos == 'after'}"></div>

</div>

</template>

<style lang="scss" scoped>
.indicator{
  display: none;
  &.dragTop, &.dragBottom { display: block; }
  &.dragTop { top: -2px; }
  &.dragBottom { bottom: -4px; }
  z-index: 1;
  pointer-events: none;
  position:absolute;
  border-radius: 3px;
  height: 6px;
  width: 100%;
  background: rgba(black, 40%);
}
</style>

<script>
//import { mapGetters,  mapActions } from 'vuex';

import Moment from 'moment';

export default {
  name: 'PriorityJobBlock',
  components: {

  },
  props: {
    job: { type: Object, required: true },
    enableDrop: { type: Boolean, required: false, default: true },
  },
  data(){ return {
    dragover: false,
    dragPos: "",
  }},
  computed:{

  },
  watch: {
  },

  methods: {

    moment(m){ return new Moment(m); },

    leftClick(){
    },

    rightClick(){
    },

    dblClick(){
      this.$nextTick(() => {
        window.open(`/dash/jobs/all/${this.job.xid}`, '_blank');
      });
    },

    dragStart(e){
      e.dataTransfer.setData("prioritise-job", JSON.stringify({
        job: this.job
      }));
      e.dataTransfer.setDragImage(new Image(), 0, 0);
    },

    dragEnter(){ this.dragover = this.enableDrop && true; },
    dragLeave(){ this.dragover = false; },
    dragOver(e){
      if(!this.enableDrop) return;
      this.dragover = true;
      const rect = this.$el.getBoundingClientRect();
      const offset = e.clientY - rect.top;
      this.dragPos = offset < rect.height/2 ? "before" : "after";
      e.preventDefault();
    },
    dragDrop(e){
      if(!this.enableDrop) return;
      this.dragover = false;
      let dropData = JSON.parse(e.dataTransfer.getData("prioritise-job"));
      let job = dropData.job;
      this.$emit('prioritiseIntent', { job, position: this.dragPos, siblingId: this.job.xid });
      e.preventDefault();
    },
  


  },
  mounted(){
  }
}
</script>
